import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AdminLogin() {
  const navigate = useNavigate();

  useEffect(() => {
    // if already authenticated, go to dashboard
    api.get("/auth/me").then(() => navigate("/dashboard", { replace: true })).catch(() => {});
  }, [navigate]);

  const login = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-heirloom-bone">
      <div className="hidden lg:block relative overflow-hidden bg-heirloom-emerald">
        <img
          src="https://images.pexels.com/photos/19162946/pexels-photo-19162946.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=800"
          alt="Arihant Events"
          className="w-full h-full object-cover opacity-70"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-heirloom-emerald via-heirloom-emerald/40 to-transparent" />
        <div className="absolute bottom-12 left-12 text-heirloom-bone">
          <div className="font-display text-5xl">Arihant<span className="text-heirloom-gold">.</span></div>
          <p className="overline text-heirloom-gold mt-3">Admin Studio</p>
        </div>
      </div>

      <div className="flex flex-col items-center justify-center p-10">
        <div className="w-full max-w-sm">
          <span className="overline text-heirloom-crimson">Welcome back</span>
          <h1 className="font-display text-4xl md:text-5xl tracking-tight text-heirloom-obsidian mt-4">
            Sign in to your studio
          </h1>
          <p className="font-body text-heirloom-obsidian/60 mt-4 leading-relaxed">
            Manage inquiries, portfolio, testimonials and settings for Arihant Event Management Services.
          </p>

          <button
            data-testid="google-login-btn"
            onClick={login}
            className="mt-10 w-full flex items-center justify-center gap-3 bg-heirloom-obsidian text-heirloom-bone px-6 py-4 rounded-full hover:scale-[0.98] hover:ring-1 hover:ring-heirloom-gold transition-transform duration-300"
          >
            <svg width="20" height="20" viewBox="0 0 48 48"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.9 29.3 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.5 6.5 29.5 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.3-.4-3.5z"/><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 16 19 12 24 12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.5 6.5 29.5 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/><path fill="#4CAF50" d="M24 44c5.2 0 10-2 13.6-5.2l-6.3-5.3C29.2 35 26.7 36 24 36c-5.3 0-9.7-3.1-11.3-7.9l-6.5 5C9.6 39.6 16.2 44 24 44z"/><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.1-4 5.5l6.3 5.3C41.4 36.4 44 30.7 44 24c0-1.3-.1-2.3-.4-3.5z"/></svg>
            Continue with Google
          </button>

          <p className="font-body text-xs text-heirloom-obsidian/40 mt-6 text-center">
            Authorized personnel only.
          </p>
        </div>
      </div>
    </div>
  );
}
